import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ChatAlert } from 'app/models/forms/vendor/chat-alert.model';

@Injectable({
	providedIn: 'root',
})
export class ChatAlertService {
	private static readonly SEEN_KEY = 'chatAlertsSeenAt';

	constructor(private readonly httpClient: HttpClient) {}

	getAlerts(clientId: string): Observable<ChatAlert[]> {
		return this.httpClient.get<ChatAlert[]>(`${environment.apiUrl}forms/clients/${clientId}/chat-alerts`);
	}

	getRecipientStatus(clientId: string): Observable<boolean> {
		return this.httpClient.get<boolean>(`${environment.apiUrl}forms/clients/${clientId}/chat-alerts/recipient-status`);
	}

	/**
	 * Bell notifications clear per browser rather than by marking the conversations read:
	 * the inbox unread badges track who has actually answered the vendor, and dismissing a
	 * bell notification must not make a waiting conversation look handled.
	 */
	markSeen(alerts: ChatAlert[]): void {
		const latest = alerts.reduce((newest, alert) => (alert.lastMessageDate > newest ? alert.lastMessageDate : newest), '');
		if (latest) {
			localStorage.setItem(ChatAlertService.SEEN_KEY, latest);
		}
	}

	countUnseen(alerts: ChatAlert[]): number {
		const seenAt = localStorage.getItem(ChatAlertService.SEEN_KEY) ?? '';
		return alerts
			.filter((alert) => alert.lastMessageDate > seenAt)
			.reduce((total, alert) => total + alert.unreadCount, 0);
	}
}
